import { gql, useQuery } from "@apollo/client";
import { Button, Image, Layout, PageHeader, Table } from "antd";
import { useApplicationContext } from "components/Application";
import React, { Fragment } from "react";
import { useNavigate, useParams } from "react-router";

const articleItemQuery = gql`
  query($id: ID!) {
    articleItem(id: $id) {
      id
      suggestedItems {
        id
        code
        nameEn
        cover
        referenceItem {
          id
          code
          nameEn
        }
        brand {
          id
          nameEn
        }
        season {
          id
          nameEn
        }
      }
    }
  }
`;

export const List: React.FC<{}> = () => {
  const {
    siteEnvironment: { appEndpointStore },
  } = useApplicationContext();
  const navigate = useNavigate();
  const { id } = useParams();

  const variables = { id };
  const { loading, data } = useQuery(articleItemQuery, { variables, fetchPolicy: "cache-and-network" });

  const handleTableChange = () => {};

  const columns = [
    {
      title: "Cover",
      dataIndex: "cover",
      render: (value: string, resource: any) => <Image src={`${appEndpointStore}${value}`} width={50} />,
    },
    {
      title: "Code",
      dataIndex: "code",
    },
    {
      title: "Variant of",
      render: (value: string, resource: any) => (resource.referenceItem ? resource.referenceItem?.code : "---"),
    },
    {
      title: "Name",
      dataIndex: "nameEn",
    },
    {
      title: "Brand",
      render: (value: string, resource: any) => resource.brand.nameEn,
    },
    {
      title: "Season",
      render: (value: string, resource: any) => resource.season.nameEn,
    },
  ];

  return (
    <Fragment>
      <PageHeader
        ghost={true}
        title="Suggestions"
        extra={
          <Button type="primary" onClick={() => navigate("edit")}>
            Edit
          </Button>
        }
      />
      <Layout.Content className="content">
        <Table
          rowKey="id"
          loading={loading}
          columns={columns}
          dataSource={data?.articleItem?.suggestedItems}
          pagination={false}
          onChange={handleTableChange}
        />
      </Layout.Content>
    </Fragment>
  );
};
